export const createFaceLandmarkerWorker = () =>
  new Worker(new URL("./FaceLandmarkerWorker.js", import.meta.url), {
    name: "kyc-face-landmarker",
  });
